import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Truck = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M19.148 6.971A2.008 2.008 0 0 0 17.434 6H15V5a1 1 0 0 0-1-1H4c-1.103 0-2 .897-2 2v10c0 .77.441 1.432 1.081 1.766A3.418 3.418 0 0 0 3 18.5C3 20.43 4.57 22 6.5 22s3.5-1.57 3.5-3.5c0-.171-.026-.335-.051-.5h3.102c-.025.165-.051.329-.051.5 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.171-.026-.335-.051-.5H20c1.103 0 2-.897 2-2v-4a.995.995 0 0 0-.143-.515l-2.709-4.514zM15 8h2.434l1.8 3H15V8zM6.5 20c-.827 0-1.5-.673-1.5-1.5S5.673 17 6.5 17s1.5.673 1.5 1.5S7.327 20 6.5 20zm10 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z", key: "k0" })));
});
Truck.displayName = 'Truck';
export var TruckDimensions = { height: 24, width: 24 };
